import React from "react";
import { useTranslation } from "react-i18next";
import {
  H4_ABOUT_IMG01,
  H4_ABOUT_IMG02,
  H4_ABOUT_SHAPE,
} from "../../lib/assets";
import { Odometer } from "../Odometer/Odometer";

export const AboutTen = () => {
  const { t } = useTranslation();

  return (
    <section className="about-area-ten">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-6 col-md-8">
            <div className="about-img-wrap-five about-img-wrap-ten">
              <img src={H4_ABOUT_IMG01} alt="" />
              <img src={H4_ABOUT_IMG02} alt="" data-parallax='{"y" : 100 }' />
              <div className="experience-wrap">
                <h2 className="title">
                  15 <span>{t("aboutPage.years")}</span>
                </h2>
              </div>
            </div>
          </div>

          <div className="col-lg-6">
            <div className="about-content-five about-content-ten">
              <div className="section-title-two mb-30">
                <span className="sub-title">{t("aboutPage.subTitle")}</span>
                <h2 className="title">{t("aboutPage.title")}</h2>
              </div>
              <p>{t("aboutPage.text1")}</p>
              <p>{t("aboutPage.text2")}</p>
              <div className="about-success-wrap">
                <ul className="list-wrap">
                  <li>
                    <div className="icon">
                      <i className="flaticon-profit"></i>
                    </div>
                    <div className="content">
                      <h2 className="count">
                        <Odometer end={98} />%
                      </h2>
                      <p>{t("aboutPage.successDeals")}</p>
                    </div>
                  </li>
                  <li>
                    <div className="icon">
                      <i className="flaticon-trophy"></i>
                    </div>
                    <div className="content">
                      <h2 className="count">
                        <Odometer end={99} />%
                      </h2>
                      <p>{t("aboutPage.satisfiedClients")}</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="about-shape-five">
        <img src={H4_ABOUT_SHAPE} alt="" />
      </div>
    </section>
  );
};
